import { render, staticRenderFns } from "./ShoppingListV1.vue?vue&type=template&id=29a20df6&scoped=true"
import script from "./ShoppingListV1.vue?vue&type=script&lang=js"
export * from "./ShoppingListV1.vue?vue&type=script&lang=js"
import style0 from "./ShoppingListV1.vue?vue&type=style&index=0&id=29a20df6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29a20df6",
  null
  
)

export default component.exports